export default {
      id: "Icon--audioMedium-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--audioMedium",
      toString: function () {
        return this.url;
      }
    }